import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { AboutUsLine } from "../../svgImage";
import styles from "./LandingPage.module.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import mango from "../../assets/mango.jpg";
import red_velvet from "../../assets/red_velvet.jpg";
import Vanila from "../../assets/Vanila.jpg";
import Protein_cookies from "../../assets/Protein-cookies.jpg";
import sandwich_cookie from "../../assets/sandwich_cookie.jpg";
import Caramel_cupcakes from "../../assets/Caramel-cupcakes.jpg";
import chocolate_cupcakes from "../../assets/chocolate-cupcakes.jpg";
import whole_wheat from "../../assets/whole-wheat.jpg";
import burntCheesecake from "../../assets/umami/burntCheesecake.jpg";
import { ManualImageCarousel } from "../custom/Carousel";

const MustTryComponent = () => {
  const isMobile = useMediaQuery("(max-width:468px)");
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const storeLink = process.env.REACT_APP_PRASADAM_STORE_LINK;
  const images = [
    {
      src: mango,
      name: "Mango",
    },
    {
      src: red_velvet,
      name: "Red velvet",
    },
    {
      src: burntCheesecake,
      name: "Classic Burnt Cheesecake",
    },

    {
      src: Vanila,
      name: "Vanilla",
    },
    {
      src: Protein_cookies,
      name: "Protein cookies",
    },
    {
      src: sandwich_cookie,
      name: "Sandwich cookies",
    },
    {
      src: Caramel_cupcakes,
      name: "Caramel cupcakes",
    },
    {
      src: chocolate_cupcakes,
      name: "Chocolate cupcakes",
    },
    {
      src: whole_wheat,
      name: "Whole wheat",
    },
  ];

  return (
    <Box
      maxWidth="940px"
      width="100%"
      margin="auto"
      display="flex"
      flexDirection={"column"}
      mt={"100px"}
      gap={{ xs: 4, md: 3 }}
      px={{ xs: 2, sm: 3, md: 0 }}
    >
      {/* LEFT SECTION */}
      <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <AboutUsLine width={isMobile ? "60px" : "80px"} />
          <Typography
            className={styles.Aboutustext}
            paddingLeft={1}
            fontSize={{ xs: "18px", sm: "20px", md: "22px" }}
          >
            Desserts
          </Typography>
        </Box>

        <Typography
          className={styles.AboutUsShortDiscription}
          mt="20px"
          fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
        >
          Tried, tasted, and loved—explore <br /> our top picks!
        </Typography>
      </Box>

      {/* RIGHT SECTION – CAROUSEL */}
      <Box
        width="100vw"
        mt="24px"
        sx={{
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
        }}
      >
        <ManualImageCarousel
          cards={images}
          paddingLeft="calc((100vw - 940px) / 2)"
          paddingRight="calc((100vw - 940px) / 2)"
        />
      </Box>
    </Box>
  );
};

export const CourselCard = (props) => {
  const { image, name, storeLink } = props;
  const handlerOrderNow = () => {
    window.location.href = storeLink;
  };
  return (
    <div className={styles.cardContainer}>
      <img src={image} alt={name} className={styles.image} />
      <div className={styles.contentOverlay}>
        <div className={styles.title}>
          <Typography className={styles.cardTitle}>{name}</Typography>
        </div>
        <button className={styles.button} onClick={handlerOrderNow}>
          Order now
        </button>
      </div>
    </div>
  );
};

export default MustTryComponent;
